import { DownloadFile, enqueueSnackbar, UploadFile, UploadFiles, FetchDownloads } from 'actions';
import {
	GetClustersNamesRequest,
	GenerateReportRequest,
	GetAcceptanceReportsActivationDatesRequest,
	GetReportLastUpdateRequest,
	UpdateAcceptanceReportsRequest
} from '../requests/ReportsAcceptanceRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const RESET_FIELDS = 'RESET_FIELDS';
export const GET_CLUSTERS_NAMES = 'GET_CLUSTERS_NAMES';
export const GET_ACTIVATION_DATES = 'GET_ACTIVATION_DATES';
export const GET_REPORT_LAST_UPDATE = 'GET_REPORT_LAST_UPDATE';

const onSetFormState = value => ({
	type: SET_FORM_STATE,
	formState: value
});

const onResetFields = () => ({
	type: RESET_FIELDS
});

const onGetClustersNames = value => ({
	type: GET_CLUSTERS_NAMES,
	clustersNames: value
});

const onGetActivationDates = value => ({
	type: GET_ACTIVATION_DATES,
	activationDates: value
});

const onGetReportLastUpdate = value => ({
	type: GET_REPORT_LAST_UPDATE,
	lastUpdate: value
});

export const SetFormState = value => dispatch => {
	dispatch(onSetFormState(value));
};

export const ResetFields = () => dispatch => {
	dispatch(onResetFields());
};

export const GetClustersNames = (activationDate) => async dispatch => {
	await GetClustersNamesRequest(activationDate)
		.then(response => {
			dispatch(onGetClustersNames(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const UpdateAcceptanceReports = (userId, reportType, activationDate, clusterName) => async dispatch => {
	await UpdateAcceptanceReportsRequest(userId, reportType, activationDate, clusterName)
		.then(response => {
			dispatch(
				enqueueSnackbar({
					message: "Acceptance reports updated successfully.",
					options: { variant: "success" }
				})
			);
			dispatch(GetReportLastUpdate(reportType, activationDate, clusterName));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: "warning" }
					})
				);
			}
		});
};

export const GetReportLastUpdate = (reportType, activationDate, clusterName) => async dispatch => {
	await GetReportLastUpdateRequest(reportType, activationDate, clusterName)
		.then(response => {
			dispatch(onGetReportLastUpdate(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetAcceptanceReportsActivationDates = () => async dispatch => {
	await GetAcceptanceReportsActivationDatesRequest()
		.then(response => {
			dispatch(onGetActivationDates(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GenerateReport = (userId, clusterName, preStartDate, preEndDate, postStartDate, postEndDate) => async dispatch => {
	await GenerateReportRequest(userId, clusterName, preStartDate, preEndDate, postStartDate, postEndDate)
		.then(response => {
			dispatch(FetchDownloads(userId, 'ReportKpis'));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

